/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceMeasurementErrorDtoPayload
 */
export interface DeviceMeasurementErrorDtoPayload {
    /**
     * 
     * @type {any}
     * @memberof DeviceMeasurementErrorDtoPayload
     */
    chambers?: any | null;
    /**
     * 
     * @type {any}
     * @memberof DeviceMeasurementErrorDtoPayload
     */
    details?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDtoPayload
     */
    $type?: DeviceMeasurementErrorDtoPayloadTypeEnum;
}


/**
 * @export
 */
export const DeviceMeasurementErrorDtoPayloadTypeEnum = {
    SystemCollectionsGenericDictionary2PtwModelSharedErrorsPtwErrorPayloadTypePtwModelSharedErrorsSystemObjectSystemPrivateCoreLibSystemPrivateCoreLib: 'System.Collections.Generic.Dictionary`2[[Ptw.ModelShared.Errors.PtwError.PayloadType, Ptw.ModelShared.Errors],[System.Object, System.Private.CoreLib]], System.Private.CoreLib'
} as const;
export type DeviceMeasurementErrorDtoPayloadTypeEnum = typeof DeviceMeasurementErrorDtoPayloadTypeEnum[keyof typeof DeviceMeasurementErrorDtoPayloadTypeEnum];



/**
 * Check if a given object implements the DeviceMeasurementErrorDtoPayload interface.
 */
export function instanceOfDeviceMeasurementErrorDtoPayload(value?: unknown): value is DeviceMeasurementErrorDtoPayload {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DeviceMeasurementErrorDtoPayloadTypeEnum)[0];
}

export function DeviceMeasurementErrorDtoPayloadFromJSON(json: any): DeviceMeasurementErrorDtoPayload {
    return DeviceMeasurementErrorDtoPayloadFromJSONTyped(json, false);
}

export function DeviceMeasurementErrorDtoPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceMeasurementErrorDtoPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'chambers': json['Chambers'] == null ? undefined : json['Chambers'],
        'details': json['Details'] == null ? undefined : json['Details'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DeviceMeasurementErrorDtoPayloadToJSON(value?: DeviceMeasurementErrorDtoPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'Chambers': value['chambers'],
        'Details': value['details'],
        '$type': value['$type'],
    });
}

